import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { Box, Typography } from "@mui/material";

const AdminLineChart = ({ data, title = "Orders & Revenue Over Time" }) => {
  return (
    <Box sx={{ width: "100%", height: 400, p: 2 }}>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        {title}
      </Typography>

      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="label" />
          <YAxis
            yAxisId="left"
            orientation="left"
            allowDecimals={false}
            label={{ value: "Orders", angle: -90, position: "insideLeft" }}
          />
          <YAxis
            yAxisId="right"
            orientation="right"
            label={{ value: "Revenue ($)", angle: 90, position: "insideRight" }}
          />
          <Tooltip
            formatter={(value) =>
              typeof value === "number" ? value.toFixed(2) : value
            }
          />
          <Legend />
          <Line
            yAxisId="left"
            type="monotone"
            dataKey="orders"
            stroke="#1976d2"
            strokeWidth={2}
            activeDot={{ r: 6 }}
            name="Orders"
          />
          <Line
            yAxisId="right"
            type="monotone"
            dataKey="revenue"
            stroke="#388e3c"
            strokeWidth={2}
            dot={false}
            name="Revenue"
          />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default AdminLineChart;
